import React from 'react';
import Form from 'react-bootstrap/Form';
import { FaList, FaPencilAlt, FaTrash, FaHome, FaLayerGroup, FaPhoneAlt, FaHandshake } from 'react-icons/fa';

import Const from '../../util/Constants';
import Display from '../../util/Display';
import ActionController from '../../controller/ActionController';
import { Badge } from 'react-bootstrap';

class TableRow extends React.Component {

  isChecked = id => this.props.selected && this.props.selected.find(item => item === id);

  render() {
    const i = this.props.index;
    let columns = <td key="no_records" colSpan={this.props.fieldLength}>No Records Found</td>;

    if (this.props.model !== undefined) {
      columns = this.props.fields.map(field => {
        return <td key={`td_${i}_${field}`}
          onClick={evt => this.props.onPreview(i, evt.metaKey || evt.ctrlKey || evt.keyCode === 91 || evt.keyCode === 224)}>
          {Display.FieldValue(this.props.data, field, this.props.model)}
        </td>;
      });
      const index = <td key={`td_${i}_index`}>
        {this.props.onSelect ?
          <Form.Check type="checkbox">
            <Form.Check.Input type="checkbox" checked={this.isChecked(this.props.data.id)}
              onChange={evt => evt.target.checked ? this.props.onSelect(this.props.data.id)
                : this.props.onRemove(this.props.data.id)} />
            <Form.Check.Label>{this.props.data.id}</Form.Check.Label>
          </Form.Check>
          : this.props.data.id
        }
      </td>;

      const action =
        <td key={`td_${i}_action`}>
          {ActionController.checkAction(Const.PermView, this.props.preview, this.props.actions, this.props.data) ?
            <Badge variant="primary" size='sm' className='m-1 p-2' onClick={(evt) => this.props.onPreview(i, evt.metaKey || evt.ctrlKey || evt.keyCode === 91 || evt.keyCode === 224)}> <FaList className="actionbtnp" color='#ffffff' /> View </Badge> : null}
          {ActionController.checkAction(Const.PermUpdate, this.props.update, this.props.actions, this.props.data) ?
            <Badge variant="warning" size='sm' className='m-1 p-2 text-white' onClick={() => this.props.onAddEdit(i)}> <FaPencilAlt color='#ffffff' /> Edit</Badge> : null}
          {ActionController.checkAction(Const.PermDelete, this.props.delete, this.props.actions, this.props.data) ?
            <Badge variant="danger" className='m-1 p-2' size='sm' onClick={() => this.props.onDelete(i)}><FaTrash className="actionbtnd" color='#ffffff' /> Delete</Badge> : null}
          {this.props.findProperties ?
            <Badge variant="success" className='m-1 p-2' size='sm' onClick={() => this.props.findProperties(i)} ><FaHome className="actionbtnd" color='#ffffff' /> Find Property</Badge> : null}
          {this.props.findLeads ?
            <Badge size='sm' variant="secondary" className='m-1 p-2' onClick={() => this.props.findLeads(i)}><FaLayerGroup color='#ffffff' className="actionbtnp" /> Find leads </Badge> : null}
          {this.props.onCallClick ?
            <Badge size='sm' variant="info" className='m-1 p-2' onClick={() => this.props.onCallClick(i)}> <FaPhoneAlt color='#ffffff' className="actionbtnp" />Call</Badge> : null}
          {this.props.onMeetingClick ?
            <Badge size='sm' variant="primary" className='m-1 p-2' onClick={() => this.props.onMeetingClick(i)}> <FaHandshake color='#ffffff' className="actionbtnp" />Meeting</Badge> : null}
        </td>;
      columns = [index, ...columns, action];
    }
    return (
      <tr>{columns}</tr>
    );
  }
}

export default TableRow;